import React, { useState } from 'react';
import { Table, Badge, Button, Form, InputGroup } from 'react-bootstrap';

const CategoriasTable = ({ categorias, onEdit, onDelete, productosCount = {} }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [sortBy, setSortBy] = useState('id'); // 'id' o 'nomCategoria'
  const [sortOrder, setSortOrder] = useState('asc'); // 'asc' o 'desc'

  // Filtrar categorías por búsqueda
  const categoriasFiltradas = categorias.filter((cat) =>
    cat.nomCategoria.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Ordenar categorías
  const categoriasOrdenadas = [...categoriasFiltradas].sort((a, b) => {
    const aValue = sortBy === 'id' ? a.id : a.nomCategoria.toLowerCase();
    const bValue = sortBy === 'id' ? b.id : b.nomCategoria.toLowerCase();
    
    if (sortOrder === 'asc') {
      return aValue > bValue ? 1 : -1;
    } else {
      return aValue < bValue ? 1 : -1;
    }
  });

  const handleSort = (column) => {
    if (sortBy === column) {
      setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
    } else {
      setSortBy(column);
      setSortOrder('asc');
    }
  };

  const getSortIcon = (column) => {
    if (sortBy !== column) return <i className="fas fa-sort text-muted ms-1"></i>;
    return sortOrder === 'asc' 
      ? <i className="fas fa-sort-up ms-1"></i>
      : <i className="fas fa-sort-down ms-1"></i>;
  };

  return (
    <>
      {/* Barra de búsqueda */}
      <div className="mb-3">
        <InputGroup>
          <InputGroup.Text>
            <i className="fas fa-search"></i>
          </InputGroup.Text>
          <Form.Control
            type="text"
            placeholder="Buscar categoría por nombre..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </InputGroup>
      </div>

      {/* Tabla */}
      <Table hover responsive className="align-middle">
        <thead style={{ backgroundColor: '#f8f5f0' }}>
          <tr>
            <th 
              style={{ cursor: 'pointer', width: '80px' }}
              onClick={() => handleSort('id')}
            >
              ID {getSortIcon('id')}
            </th>
            <th 
              style={{ cursor: 'pointer' }}
              onClick={() => handleSort('nomCategoria')}
            >
              Nombre de Categoría {getSortIcon('nomCategoria')}
            </th>
            <th style={{ width: '150px' }}>Productos</th>
            <th style={{ width: '120px' }}>Estado</th>
            <th style={{ width: '180px', textAlign: 'center' }}>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {categoriasOrdenadas.length === 0 ? (
            <tr>
              <td colSpan="5" className="text-center py-4 text-muted">
                <i className="fas fa-inbox fa-2x mb-2 d-block"></i>
                {searchTerm ? 'No se encontraron categorías' : 'No hay categorías registradas'}
              </td>
            </tr>
          ) : (
            categoriasOrdenadas.map((categoria) => (
              <tr key={categoria.id} style={{ transition: 'background-color 0.2s' }}>
                <td className="fw-semibold text-muted">#{categoria.id}</td>
                <td className="fw-medium">{categoria.nomCategoria}</td>
                <td>
                  <Badge 
                    bg="light" 
                    text="dark" 
                    className="fw-normal"
                    style={{ fontSize: '0.9rem' }}
                  >
                    <i className="fas fa-box me-1"></i>
                    {productosCount[categoria.id] || 0} productos
                  </Badge>
                </td>
                <td>
                  {categoria.activo ? (
                    <Badge bg="success" className="px-3 py-2">
                      <i className="fas fa-check-circle me-1"></i>
                      Activo
                    </Badge>
                  ) : (
                    <Badge bg="secondary" className="px-3 py-2">
                      <i className="fas fa-times-circle me-1"></i>
                      Inactivo
                    </Badge>
                  )}
                </td>
                <td className="text-center">
                  <Button
                    variant="outline-primary"
                    size="sm"
                    className="me-2"
                    onClick={() => onEdit(categoria)}
                    style={{ borderColor: '#c4956a', color: '#c4956a' }}
                  >
                    <i className="fas fa-edit me-1"></i>
                    Editar
                  </Button>
                  <Button
                    variant="outline-danger"
                    size="sm"
                    onClick={() => onDelete(categoria)}
                  >
                    <i className="fas fa-trash"></i>
                  </Button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </Table>

      {/* Footer con contador */}
      {categoriasOrdenadas.length > 0 && (
        <div className="text-muted small mt-2">
          Mostrando {categoriasOrdenadas.length} de {categorias.length} categorías
        </div>
      )}
    </>
  );
};

export default CategoriasTable;
